// admin/src/pages/Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../components/TopNav.jsx';

export default function Home() {
  const cards = [
    {
      to: '/programs',
      icon: '📚',
      title: 'Programs',
      description: 'Manage educational programs and majors',
      color: '#3b82f6',
      bgColor: '#eff6ff'
    },
    {
      to: '/questions',
      icon: '📝',
      title: 'Questions',
      description: 'Create and edit quiz questions across all phases',
      color: '#8b5cf6',
      bgColor: '#f5f3ff'
    },
    {
      to: '/result-content',
      icon: '📄',
      title: 'Result Content',
      description: 'Configure result pages and recommendations',
      color: '#10b981',
      bgColor: '#ecfdf5'
    },
    {
      to: '/sessions',
      icon: '👥',
      title: 'Sessions',
      description: 'View student quiz sessions and responses',
      color: '#f59e0b',
      bgColor: '#fffbeb'
    },
    {
      to: '/analytics',
      icon: '📊',
      title: 'Analytics',
      description: 'View insights and statistics',
      color: '#ec4899',
      bgColor: '#fdf2f8'
    },
    {
      to: '/branding',
      icon: '🎨',
      title: 'Branding',
      description: 'Customize theme and appearance',
      color: '#06b6d4',
      bgColor: '#ecfeff'
    }
  ];

  return (
    <div className="admin-container">
      <TopNav />
      <div className="page-pad">
        <div className="home-container">
          {/* Header */}
          <header className="home-header">
            <h1 className="home-title">Welcome to Admin Portal</h1>
            <p className="home-subtitle">
              Manage your quiz content, view sessions, and analyze results
            </p>
          </header>

          {/* Cards Grid */}
          <div className="home-grid">
            {cards.map((card) => (
              <Link
                key={card.to}
                to={card.to}
                className="home-card"
                style={{ 
                  '--card-color': card.color,
                  '--card-bg': card.bgColor 
                }}
              >
                <div className="home-card__icon" style={{ background: card.bgColor }}>
                  {card.icon}
                </div>
                <h2 className="home-card__title">{card.title}</h2>
                <p className="home-card__desc">{card.description}</p>
              </Link>
            ))}
          </div>

          {/* Quick Access */}
          <div className="home-quick-access">
            <h2 className="home-quick-access__title">Quick Access</h2>
            <div className="home-quick-access__grid">
              <div className="home-quick-access__item">
                <div className="home-quick-access__label">Most Used</div>
                <Link to="/questions" className="home-quick-access__link">
                  Questions →
                </Link>
              </div>
              <div className="home-quick-access__item">
                <div className="home-quick-access__label">View Activity</div>
                <Link to="/sessions" className="home-quick-access__link">
                  Sessions →
                </Link>
              </div>
              <div className="home-quick-access__item">
                <div className="home-quick-access__label">Check Data</div>
                <Link to="/analytics" className="home-quick-access__link">
                  Analytics →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}